export default [
    {
        path: '/logs/audit',
        name: 'audit-log',
        component: () => import('../../pages/logs/AuditPage.vue'),
        meta: {
            title: 'Audit Log',
            requiresAuth: true,
        },
    },
    {
        path: '/logs/error',
        name: 'error-log',
        component: () => import('../../pages/logs/ErrorPage.vue'),
        meta: {
            title: 'Error Log',
            requiresAuth: true,
        },
    },
    {
        path: '/logs/rate-limit',
        name: 'rate-limit-log',
        component: () => import('../../pages/logs/RateLimitPage.vue'),
        meta: {
            title: 'Rate Limit Blocks',
            requiresAuth: true,
        },
    },
    {
        path: '/logs/sts',
        name: 'sts-logs',
        component: () => import('../../pages/logs/StsLogsPage.vue'),
        meta: {
            title: 'STS Logs',
            requiresAuth: true,
        },
    },
]
